import { H3 } from "@blueprintjs/core"
import styled from "@emotion/styled"
import { FlexContainerAndItem } from "../../../../styled/flexbox.styled"
import { ShadowContainer } from "../../../../styled/layout.styled"
import { SCIENT_COLORS } from "../../../../styled/scientColors"

export const SpinnerContainer = styled(FlexContainerAndItem)({
  overflow: "auto",
  padding: "10px 0 10px 0",
})

export const WaveListContainer = styled(ShadowContainer)({
  width: "50%",
  height: "100%",
  overflowY: "auto",
})

export const DetailContainer = styled(FlexContainerAndItem)({
  width: "50%",
  padding: "20px",
  backgroundColor: SCIENT_COLORS.darkGray1,
  borderRadius: "10px",
  height: "100%",
  display: "flex",
  flexDirection: "column",
})

export const StyledH3 = styled(H3)`
  margin: 0 auto 12px;
`
